import React from 'react';
import { Box, Typography } from '@mui/material';
import { AlertTriangle, PenLine } from 'lucide-react';
import { TOKENS } from '../state/colors';
import { fs } from '../state/typography';
import { formatDiaMes, formatDiaMesHora } from '../state/formatVersiones';

const texto = { fontFamily: 'Poppins, sans-serif' };

interface AvisoEdicionProps {
  siguienteVersion: number;
  versionVigente: number;
  enviadaEn: string | null;
}

// SPEC-206 (RN-010, UC-004) — en un BORRADOR con versiones enviadas: qué se edita y qué tiene el
// cliente. Se usa en el drawer del Centro y en el Detalle de Cotización.
export const AvisoEdicionVersion: React.FC<AvisoEdicionProps> = ({ siguienteVersion, versionVigente, enviadaEn }) => (
  <Box
    role="status"
    data-testid="aviso-edicion-version"
    sx={{
      display: 'flex', gap: '10px', alignItems: 'flex-start', marginTop: '14px', padding: '10px 12px', borderRadius: '12px',
      backgroundColor: 'rgba(147,64,143,.07)', border: `1px solid ${TOKENS.purpleSoft}`,
    }}
  >
    <PenLine size={16} color={TOKENS.purple} aria-hidden style={{ marginTop: 2, flexShrink: 0 }} />
    <Box>
      <Typography sx={{ ...texto, fontSize: fs(13), fontWeight: 600, color: TOKENS.ink }}>Estás editando la v{siguienteVersion}</Typography>
      <Typography sx={{ ...texto, fontSize: fs(11.5), color: TOKENS.text }}>
        El cliente tiene la v{versionVigente}{enviadaEn ? ` · enviada ${formatDiaMes(enviadaEn)}` : ''}
      </Typography>
    </Box>
  </Box>
);

// SPEC-206 (CA-016, UC-006) — hay una versión pendiente: ningún destinatario recibió el último envío.
export const AvisoEnvioFallido: React.FC<{ intentadoEn: string }> = ({ intentadoEn }) => (
  <Box
    role="alert"
    data-testid="aviso-envio-fallido"
    sx={{
      display: 'flex', gap: '10px', alignItems: 'flex-start', marginTop: '10px', padding: '10px 12px', borderRadius: '12px',
      backgroundColor: 'rgba(201,138,27,.10)', border: `1px solid ${TOKENS.amber}`,
    }}
  >
    <AlertTriangle size={16} color={TOKENS.amber} aria-hidden style={{ marginTop: 2, flexShrink: 0 }} />
    <Box>
      <Typography sx={{ ...texto, fontSize: fs(13), fontWeight: 600, color: TOKENS.ink }}>El último intento de envío falló</Typography>
      <Typography sx={{ ...texto, fontSize: fs(11.5), color: TOKENS.text }}>{formatDiaMesHora(intentadoEn)} · vuelve a enviar</Typography>
    </Box>
  </Box>
);
